// Module
var code = `<!-- clAside — subdued marginal note for advanced tangents.
     Data shape: { title?: "plain", content: [ "markdown", ... ] }
     Quieter visual weight than clCallout; used for "Under the Hood" style asides. -->
<aside class="block-cl-aside">
  {{#title}}<div class="block-cl-aside__title">{{title}}</div>{{/title}}
  <div class="block-cl-aside__content">
    {{#content}}<p>{{.}}</p>{{/content}}
  </div>
</aside>
`;
// Exports
module.exports = code;